import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';

import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { LoginInfo, LoginResult } from 'src/app/shared-core/models/auth-data.model';
import { AuthService } from 'src/app/shared-core/services/auth.service';
import { SocialAuthService, GoogleLoginProvider, FacebookLoginProvider, SocialUser } from 'angularx-social-login';
import { ApiService } from 'src/app/shared-core/services/api.service';
import { AppConfigService } from 'src/app/shared-core/services/app-config.service';
import { AppConfig } from 'src/app/shared-core/models/app-config';
import { Subject } from 'rxjs';
import { GtagService } from 'src/app/shared-core/services/gtag.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
  externalLoginUrl = '/cart/externalLogin';
  @Input() isCheckout: boolean = false;
  @Output() closeEvent = new EventEmitter<string>();
  modalToOpen: ModalDirective;
  forgetPasswordSent: boolean;
  magicLinkSent: boolean;
  config: AppConfig;
  initialized: boolean;
  initializeSubject = new Subject<boolean>();
  _show: 'login' | 'register' | null;
  savedLoginInfo: LoginInfo;
  passwordReminderTitle: string;
  forgetPasswordEmail: any;
  @Input('show') set show(val: 'login' | 'register' | null) {
    const previousValue = this._show;
    this._show = val;
    if (this.initialized) {
      this.executeShow(this._show, previousValue);
    } else {
      var subscr = this.initializeSubject.subscribe((result) => {
        this.executeShow(this._show, previousValue);
        subscr.unsubscribe();
      });
    }
  }
  get isAnySocialLoginEnabled() {
    return (!this.config.Auth?.Facebook?.Disable) ||
      (!this.config.Auth?.Google?.Disable) ||
      (!this.config.Auth?.Twitter?.Disable);
  }
  get show(): 'login' | 'register' | null {
    return this._show;
  }
  @Output() showChange = new EventEmitter<'login' | 'register' | null>();

  executeShow(dialog: 'login' | 'register' | null, oldDialog: 'login' | 'register' | null) {
    if (oldDialog === dialog) {
      return;
    }
    this.loginModal.hide();
    this.createAccountModal.hide();
    this.forgetPasswordModal.hide();
    this.showChange.emit(dialog);
    if (dialog === 'login') {
      this.loginModal.show();
      return;
    }
    if (dialog === 'register') {
      this.createAccountModal.show();
      return;
    }
    if (this.loginModal.isShown) {
      this.loginModal.hide();
    }
    if (this.createAccountModal.isShown) {
      this.createAccountModal.hide();
    }
  }

  @ViewChild('f', { static: false }) loginForm: NgForm;
  @ViewChild('loginModal') loginModal: ModalDirective;
  @ViewChild('createAccountModal') createAccountModal: ModalDirective;
  @ViewChild('forgetPasswordModal') forgetPasswordModal: ModalDirective;
  @ViewChild('magicLinkModal') magicLinkModal: ModalDirective;
  @ViewChild('twitterForm', { static: false }) twitterForm: ElementRef<HTMLFormElement>;

  constructor(
    private authService: AuthService,
    private toaster: ToastService,
    private formBuilder: FormBuilder,
    private socialAuthService: SocialAuthService,
    public apiService: ApiService,
    public appconfigService: AppConfigService,
    public gtagService: GtagService
  ) {
    this._show = null;
    this.config = appconfigService.Config;
  }

  ngAfterViewInit(): void {
    this.initialized = true;
    this.initializeSubject.next(true);
  }

  isLoggedin: boolean;
  socialLoginForm: FormGroup;
  socialUser: SocialUser;

  submitted: boolean = false;
  loginFailureMsg: string = '';
  returnURl: string = '';
  passowrdTextType: boolean;

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    this.returnURl = urlParams.get('ReturnUrl');
    this.authService.getSavedLoginInfo().subscribe((result) => {
      this.savedLoginInfo = result;
    });

    //#region "Social Login Forms"
    this.socialLoginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
  //#region "Social Login with Google"

  signInWithTwitter(): void {
    // currently not working
    this.twitterForm.nativeElement.submit();
  }

  signInWithGoogle(): void {
    this.socialSignIn(GoogleLoginProvider.PROVIDER_ID, 'Google');
  }

  signInWithFacebook(): void {
    this.socialSignIn(FacebookLoginProvider.PROVIDER_ID, 'Facebook');
  }

  socialSignIn(provider_Id: string, type: string) {
    this.socialAuthService
      .signIn(provider_Id)
      .then((user) => {
        this.authService.externallogin(user).subscribe((result) => {
          this.gtagService.login(type);
          //called from checkout page
          this.showLoginResult(result);
        });
      })
      .catch((reason) => {
        // if the authorization failed, we supress as we don't intend to handle it in any way.
      });
  }

  logOut(): void {
    this.socialAuthService.signOut();
  }

  togglePasswordTextType() {
    this.passowrdTextType = !this.passowrdTextType;
  }

  onLoginSubmit() {
    this.loginFailureMsg = '';
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    let loginInfo = new LoginInfo();
    loginInfo.Email = this.loginForm.value.email;
    loginInfo.PasswordHidden = btoa(this.loginForm.value.password);
    loginInfo.RememberMe = true;

    this.authService.login(loginInfo).subscribe((result) => {
      this.gtagService.login('Vistek');
      this.showLoginResult(result);
    });
    //this.signupForm.reset();
  }

  showLoginResult(result: LoginResult) {
    if (result.Success === false) {
      this.loginFailureMsg = result?.Errors[0] ?? 'Invalid login! your account is locked out';
    } else {
      this.toaster.success('Logged in successfully.', null, { messageClass: 'success' });
      this.closeEvent.emit('close-me');
      if (this.isCheckout) {
        window.location.href = '/cart/checkout';
        return;
      }
      if (this.returnURl) {
        window.location.href = this.returnURl;
        return;
      }
      if (window.location.pathname == '/cart/login') {
        window.location.href = '/';
        return;
      }
      window.location.reload();
    }
  }

  onForgetPassword(activate: boolean = false) {
    this.modalToOpen = this.forgetPasswordModal;
    this.passwordReminderTitle = activate ? 'Activate your account' : 'Forgot your password?';
    this.forgetPasswordEmail = activate ? this.savedLoginInfo?.Email : this.loginForm.value.email;
    this.loginModal.hide();
  }

  onMagicLinkActivated(){
    this.modalToOpen = this.magicLinkModal;
    this.passwordReminderTitle = 'Sign in with Magic Link';
    this.forgetPasswordEmail = this.savedLoginInfo?.Email;
    this.loginModal.hide();
  }

  onGuestCheckout() {
    window.location.href = '/cart/checkout';
  }

  onCloseForgotPassword() {
    this.modalToOpen = this.loginModal;
    this.forgetPasswordModal.hide();
  }

  onCloseMagicLink() {
    this.modalToOpen = this.loginModal;
    this.magicLinkModal.hide();
  }

  onClosed(event: Event) {
    // this ensures that modals do not interfere with each other
    if (this.modalToOpen) {
      this.modalToOpen.show();
      this.modalToOpen = null;
    }
  }

  onForgetPasswordOpened(event: Event) {
    this.forgetPasswordSent = false;
  }

  onMagicLinkOpened(event: Event) {
    this.magicLinkSent = false;
  }

  onCreateAccount(event: Event) {
    this.show = 'register';
  }

  onAccountExistsAction(action: 'login' | 'resetpassword') {
    if (action == 'login') {
      this.show = action;
      return;
    }
    this.show = null;
    this.forgetPasswordModal.show();
  }
}
